/**
 * Formats large numbers in Indian notation (Cr, L) or international (B, M).
 */
export function formatMarketCap(value: number, currency: string = "USD"): string {
  if (currency === "INR") {
    if (value >= 1e11) return `₹${(value / 1e11).toFixed(1)}L Cr`;
    if (value >= 1e7) return `₹${(value / 1e7).toFixed(0)} Cr`;
    return `₹${(value / 1e5).toFixed(0)} L`;
  }
  // International format for all non-INR currencies
  const symbol = currency === "GBP" ? "£" : currency === "EUR" ? "€" : currency === "JPY" ? "¥" : "$";
  if (value >= 1e12) return `${symbol}${(value / 1e12).toFixed(1)}T`;
  if (value >= 1e9) return `${symbol}${(value / 1e9).toFixed(1)}B`;
  return `${symbol}${(value / 1e6).toFixed(0)}M`;
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-IN").format(value);
}

export function formatPct(value: number, decimals = 1): string {
  return `${value >= 0 ? "+" : ""}${value.toFixed(decimals)}%`;
}
